function AccountOwnerAndAdminsCtrl($scope, $state, AccountOwnerAndAdminsService) {
    var ctrl = this;

    ctrl.setData = function(accountId) {
        AccountOwnerAndAdminsService.getAccountOwnerAndAdmins(accountId, function(data) {
            $scope.accountsData = data.accountsData;
        });
    }

    ctrl.$onInit = function() {
        // account id is the current account id if we have a filter, or 1 (System) if not
        let accountId = $state.params.accountId || 1;
        ctrl.setData(accountId);
    }
}